import React from "react";
import { Link } from 'gatsby';
import TimeToRead from './time-to-read'
import { FormattedMessage } from "react-intl";
import { PostTitle
        ,sPostLanguage
        ,sGoto
        ,sPostTitleLink
        ,PostGeneral
        ,PostExcerpt
        ,PostMetaDivider
        ,LinkCategory
        ,ImgPostDescription
       } from '../theme/globalStyle'
const _ = require('lodash');

class PostDescription extends React.Component {

    render (){

        const { slug, titlepost, excerpt, topico, timeToRead, langKey, imgSrc } = this.props;
        return    (
            <span>
                <PostGeneral>
                    {langKey && (
                            <Link css={sPostLanguage} to={`${langKey}`}>{langKey}</Link>
                        )
                    }
                    <TimeToRead timeToRead={timeToRead} />
                    <PostMetaDivider />
                    <span key={topico}>
                        <Link css={LinkCategory} to={`${langKey}/${_.kebabCase(topico)}`}>
                            {topico}
                        </Link>
                    </span>
                    <PostTitle>
                        <Link css={sPostTitleLink} to={slug}>{titlepost}</Link>
                    </PostTitle>
                    {imgSrc && (
                            <ImgPostDescription src={imgSrc.publicURL} />
                        )
                    }
                    <PostExcerpt>
                        {excerpt}
                    </PostExcerpt>
                    <Link css={sGoto} to={slug}><FormattedMessage id="read" /></Link>
                </PostGeneral>
            </span>
        )
    }
}

export default PostDescription